<template lang="pug">
  .projects.mw7.center.ph3.mb5
    .mb3.pa3.bg-blue.br1.shadow-4.white
      h1.header.mt0.mb3 slidingjs
      p Простая легковесная библиотека, позволяющая скрывать/раскрывать какой-либо HTML элемент.
      ul.list.mb0.pl0
        li.dib.mr1
          a(href="https://github.com/aksenovdev/slidingjs").f7.db.pa2.b.link.br-pill.ph3.mr1.blue.bg-white git
        li.dib.mr1
          a(href="https://www.npmjs.com/package/slidingjs").f7.db.pa2.b.link.br-pill.blue.bg-white npm
</template>

<script>
export default {
  name: 'projects'
};
</script>

<style lang="scss" scoped></style>

